import React, { useEffect, useCallback, useState} from 'react';
import { FastLayer, Rect, Group, Stage, Layer, Circle, Line} from 'react-konva';
import {connect} from 'react-redux';

const RegionMode = ({effect, selected, width, height}) => { 
    let _selected = selected.flatMap(
        x => x.isPlaneMacro ? x.parameters : x);
    return _selected
           .map(
            ({min, max, originalMin, originalMax, depthParameter}) =>
                   <Rect
                     strokeShadowEnabled={false}
                     perfectDrawing={false}
                     stroke= "#00a4ff"
                     fill="#23757b4f"
                     dash={[3]}
                     x={width * (min - originalMin) / (originalMax - originalMin)}
                     y={depthParameter ? height * (depthParameter.min - depthParameter.originalMin) / (depthParameter.originalMax - depthParameter.originalMin) : 0}
                     height={depthParameter ? height * (depthParameter.max - depthParameter.min) / (depthParameter.originalMax - depthParameter.originalMin) : height}
                     width={width * (max - min) / (originalMax - originalMin)}/>);
}

const mapStateToProps = (state, props) => {
  return {
      parameterMinMax: state.effects.parameterMinMax
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(RegionMode);
